import React, { useEffect, useState } from 'react';
import ContactOne from "./ContactOne";
import HeaderOne from "../../common/header/HeaderOne";
import FooterTwo from '../../common/footer/FooterTwo';
import SectionTitle from "../sectionTitle/SectionTitle";
import { useTranslation } from 'react-i18next';



const Contact = () => {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 576px)');
        const handler = (e) => setIsMobile(e.matches);
        handler(mq);
        mq.addEventListener ? mq.addEventListener('change', handler) : mq.addListener(handler);
        return () => {
            mq.removeEventListener ? mq.removeEventListener('change', handler) : mq.removeListener(handler);
        };
    }, []);
    return (
        <>
            {/* <SEO title="Contact || Cyberate Investments Pty Ltd" /> */}
            {/* <Layout> */}
            {/* <HeaderTopBar></HeaderTopBar> */}
            <HeaderOne></HeaderOne>
            <div className="slider-area slider-style-1 bg-transparent variation-2 page-content-hero contact-hero" style={{ minHeight: isMobile ? 320 : undefined, height: isMobile ? 'auto' : undefined, padding: isMobile ? '32px 0' : undefined }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 order-2 order-lg-1 mt_md--40 mt_sm--40" style={{ marginTop: isMobile ? 0 : undefined }}>
                            <div className="inner text-start">
                                <h1 className="title theme-gradient display-two" style={{ fontSize: isMobile ? 36 : undefined, lineHeight: isMobile ? 1.2 : undefined }}>{t("53")} </h1>
                                <p className="description" style={{ fontSize: isMobile ? 14 : undefined, lineHeight: isMobile ? 1.6 : undefined }}>{t("517")}</p>
                                {/* <div className="button-group"> */}
                                {/* <Link className="btn-default btn-medium btn-border round btn-icon" to="#">New Customer <i className="icon"><FiArrowRight /></i></Link> */}
                                {/* <Link className="btn-default btn-medium btn-border round btn-icon" to="#">联系我们<i className="icon"><FiArrowRight /></i></Link>
                                    </div> */}
                            </div>
                        </div>
                        <div className="col-lg-4 order-1 order-lg-2" style={{ marginBottom: isMobile ? 16 : undefined }}>
                            <div className="thumbnail" style={{ textAlign: isMobile ? 'center' : undefined }}>
                                <img src="./images/bg/联系我们2.png" alt="Banner Images" style={{ maxWidth: '100%', height: isMobile ? 160 : 'auto', objectFit: 'contain' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                {/* Start Contact Area  */}
                <div className="rwt-contact-area rn-section-gap" style={{ padding: isMobile ? '48px 0' : undefined }}>
                    <div className="container">
                        <ContactOne />



                    </div>
                </div>
                {/* End Contact Area  */}
            </div>


            {/* </Layout> */}
            <FooterTwo />
             {/*  <Copyright /> */}
        </>
    )
}
export default Contact;